import React, { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useSettings } from "@/contexts/SettingsContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Wordmark from "@/components/Wordmark";
import { ShieldCheck, LogIn } from "lucide-react";

export default function PanelLoginPage() {
  const { login } = useAuth();
  const { settings } = useSettings();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const u = params.get("u");
    if (u) setUsername(u);
  }, [params]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      toast.success("Giriş başarılı");
      nav("/panel/dashboard");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen silver-sheen flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <Wordmark size="lg" testid="login-wordmark" />
        </div>
        <div className="asg-card rounded-2xl p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-10 w-10 rounded-xl flex items-center justify-center" style={{ background: "linear-gradient(135deg, rgba(212,175,55,0.2), rgba(183,110,121,0.1))" }}>
              <ShieldCheck className="w-5 h-5" style={{ color: "var(--asg-primary-dark)" }} />
            </div>
            <div>
              <h1 className="font-heading text-2xl font-semibold">Yönetim Paneli</h1>
              <p className="text-xs text-[color:var(--asg-muted)]">Sadece yetkili kullanıcılar için</p>
            </div>
          </div>

          <form onSubmit={onSubmit} className="grid gap-5">
            <div className="grid gap-2">
              <Label>Kullanıcı Adı</Label>
              <Input value={username} onChange={(e) => setUsername(e.target.value)} required autoFocus
                className="bg-[color:var(--asg-surface)] border-[color:var(--asg-border)] h-11" data-testid="panel-login-username" />
            </div>
            <div className="grid gap-2">
              <Label>Şifre</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                className="bg-[color:var(--asg-surface)] border-[color:var(--asg-border)] h-11" data-testid="panel-login-password" />
            </div>
            <Button type="submit" disabled={loading} className="asg-btn-primary rounded-full h-11 border-0 font-semibold" data-testid="panel-login-submit">
              <LogIn className="w-4 h-4 mr-2" /> {loading ? "Giriş..." : "Giriş Yap"}
            </Button>
          </form>
        </div>
        <p className="text-center text-xs text-[color:var(--asg-muted)] mt-6">© {new Date().getFullYear()} {settings.site_name}</p>
      </div>
    </div>
  );
}
